export const payments = [
  {
    id: 1,
    name: "Bank Transfer",
    children: [
      {
        id: 1,
        name: "BCA",
        image: "bank/bca.png",
      },
      {
        id: 2,
        name: "BNI",
        image: "bank/bni.png",
      },
      {
        id: 3,
        name: "BRI",
        image: "bank/bri.png",
      },
      {
        id: 4,
        name: "BTN",
        image: "bank/btn.png",
      },
      {
        id: 5,
        name: "DANAMON",
        image: "bank/danamon.png",
      },
      {
        id: 6,
        name: "MANDIRI",
        image: "bank/mandiri.png",
      },
      {
        id: 7,
        name: "PERMATA",
        image: "bank/permata.png",
      },
    ],
  },
  {
    id: 2,
    name: "E-Wallet",
    children: [
      {
        id: 1,
        name: "DANA",
        image: "e-wallet/dana.png",
      },
      {
        id: 2,
        name: "FLIP",
        image: "e-wallet/flip.png",
      },
      {
        id: 3,
        name: "GOPAY",
        image: "e-wallet/gopay.png",
      },
      {
        id: 4,
        name: "OVO",
        image: "e-wallet/ovo.png",
      },
      {
        id: 5,
        name: "PAYPAL",
        image: "e-wallet/paypal.png",
      },
      {
        id: 6,
        name: "SHOPEEPAY",
        image: "e-wallet/shopeepay.png",
      },
    ],
  },
];
